var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("div", {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c("el-form", {
    attrs: {
      inline: true
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "流水原因ID/Name：",
      "label-width": "160px"
    }
  }, [_c("xingxing-options", {
    model: {
      value: _vm.searchInfo.xingxing_id,
      callback: function callback($$v) {
        _vm.$set(_vm.searchInfo, "xingxing_id", $$v);
      },
      expression: "searchInfo.xingxing_id"
    }
  })], 1), _c("el-form-item", [[_c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: function click($event) {
        return _vm.queryEvent();
      }
    }
  }, [_vm._v("查询")]), _c("el-button", {
    attrs: {
      type: "success"
    },
    on: {
      click: function click($event) {
        return _vm.openConfig();
      }
    }
  }, [_vm._v("同步cp配置")])]], 2)], 1)], 1), _c("div", [_c("el-table", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      data: _vm.tableData,
      border: "",
      "row-key": "authorityId",
      stripe: "",
      height: "600"
    }
  }, [_c("el-table-column", {
    attrs: {
      label: "序号",
      width: "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("span", [_vm._v(_vm._s(scope.$index + 1 + (_vm.page - 1) * _vm.pageSize) + " ")])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "流水原因id",
      "min-width": "180",
      prop: "xingxing_id"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "流水原因名称",
      "min-width": "180",
      prop: "xingxing_name"
    }
  })], 1)], 1), _c("el-pagination", {
    style: {
      float: "right",
      padding: "20px"
    },
    attrs: {
      "current-page": _vm.page,
      "page-size": _vm.pageSize,
      "page-sizes": [5, 30, 50, 100, 500],
      total: _vm.total,
      layout: "total, sizes, prev, pager, next, jumper"
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange
    }
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };